<template>
  <div
    class="mc-rec-ord-empty"
    :class="{ 'mc-rec-ord-empty--muted': muted }"
    role="status"
  >
    <p class="mc-rec-ord-empty__text mb-0">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'RecommendationEmptyState',
  props: {
    message: { type: String, required: true },
    muted: { type: Boolean, default: false },
  },
}
</script>
